import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import StarRoundedIcon from '@material-ui/icons/StarRounded';

const Rating = withStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    fontWeight: 'bold',
  },
  starIcon: {
    color: theme.props.palette.primary.main,
    width: '1em',
    height: '1em',
  },
  children: {
    marginLeft: theme.spacing(1),
  },
}))(
  ({ classes, children, icon: Icon = StarRoundedIcon, iconSize, ...other }) => (
    <div className={classes.root} style={other}>
      <Icon
        className={classes.starIcon}
        {...(!!iconSize && { style: { width: iconSize, height: iconSize } })}
      />
      <span className={classes.children}>{children}</span>
    </div>
  ),
);

export default Rating;
